// extracted by css-extract-rspack-plugin
export default {"progress":"CampaignCreationWizardProgress-module__progress--m_HhE"};